export function useDateFormatter() {
  const formatDateForApi = (date) => {
    if (!date) return null;

    if (date instanceof Date) {
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');
      return `${year}-${month}-${day}`;
    }

    // If it's a string, check if it's already in YYYY-MM-DD format
    if (typeof date === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(date)) {
      return date;
    }

    if (typeof date === 'string') {
      try {
        // Attempt to create a Date object. This is quite flexible with what it accepts.
        const parsedDate = new Date(date);
        // Check if parsing resulted in a valid date
        if (isNaN(parsedDate.getTime())) {
            console.warn("Could not parse date string to a valid Date object: ", date);
            return null;
        }
        const year = parsedDate.getFullYear();
        const month = (parsedDate.getMonth() + 1).toString().padStart(2, '0');
        const day = parsedDate.getDate().toString().padStart(2, '0');
        return `${year}-${month}-${day}`;
      } catch (e) {
        console.warn("Error parsing date string for API: ", date, e);
        return null; // Or handle error appropriately
      }
    }

    console.warn("Date provided is not a Date object or a recognized string format: ", date);
    return null; // Fallback for unknown types or invalid dates
  };

  return {
    formatDateForApi,
  };
} 